import { calculateDOSaturation, estimateDissolvedOxygen } from '../../utils/waterCalculations'
import type { WaterDataRow } from '../../utils/waterTable'

const hasNumber = (value: number | null | undefined): value is number => value !== null && value !== undefined

export const applyEstimatedWaterDissolvedOxygen = (row: WaterDataRow, farmAltitude: number): WaterDataRow => {
  if (!hasNumber(row.temperature)) {
    return {
      ...row,
      dissolvedOxygen: null,
      dissolvedOxygenSaturation: null
    }
  }

  const estimatedDO = estimateDissolvedOxygen(row.temperature, farmAltitude)
  const estimatedSaturation = calculateDOSaturation(estimatedDO, row.temperature, farmAltitude)

  return {
    ...row,
    dissolvedOxygen: estimatedDO,
    dissolvedOxygenSaturation: estimatedSaturation
  }
}

export const recalculateEstimatedWaterDissolvedOxygen = (rows: WaterDataRow[], farmAltitude: number): WaterDataRow[] => {
  return rows.map((row) => applyEstimatedWaterDissolvedOxygen(row, farmAltitude))
}

export const getDerivedManualDissolvedOxygenSaturation = (row: WaterDataRow, farmAltitude: number): number | null => {
  if (hasNumber(row.manualDissolvedOxygenSaturation)) {
    return row.manualDissolvedOxygenSaturation
  }

  if (!hasNumber(row.manualDissolvedOxygen) || !hasNumber(row.temperature)) {
    return null
  }

  return calculateDOSaturation(row.manualDissolvedOxygen, row.temperature, farmAltitude)
}